import { streem } from 'streem-sdk-protobuf';
import { invariant } from '@streem/toolbox';
import { RoomId, UserId, DeviceId, RoomInvitationId } from '@streem/domain-id';
export function buildRoomInviteData({ sid, roomSid, status, fromUserSid, fromDeviceSid, toUserSid, toDeviceSid, }, user) {
    invariant(sid &&
        roomSid &&
        roomSid &&
        status &&
        fromUserSid &&
        fromDeviceSid &&
        toUserSid &&
        toDeviceSid, 'Received malformed RoomInvitation from API');
    return {
        id: new RoomInvitationId(sid),
        roomId: new RoomId(roomSid),
        status: protobufMapper.roomInvitationStatusFromV1(streem.api.RoomInvitation.Status[status]),
        fromUserId: new UserId(fromUserSid),
        fromUser: user,
        fromDeviceId: new DeviceId(fromDeviceSid),
        toUserId: new UserId(toUserSid),
        toDeviceId: new DeviceId(toDeviceSid),
    };
}
// Until we have the protobuf stuff for JS figured out, we are simply mapping
// the V1 protobuf world to the current typescript world... -SA
export const protobufMapper = {
    roomInvitationStatusToV1: (status) => {
        if (status == 'UNKNOWN' || status == 'UNRECOGNIZED') {
            return 'STATUS_INVALID';
        }
        return `STATUS_${status}`;
    },
    roomInvitationStatusFromV1: (status) => {
        if (!status || status == 'STATUS_INVALID') {
            return 'UNKNOWN';
        }
        return status.substring('STATUS_'.length);
    },
};
//# sourceMappingURL=build_room_invitation.js.map